export default "__VITE_ASSET__$w23VFB8__"